module.exports = __webpack_public_path__ + "img/profit-and-loss.7ef5ae4f.png";